import React from "react";
import "./DistributeAppleMusic.css";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { FaApple } from "react-icons/fa";

const DistributeAppleMusic = () => {

  const steps = [
    "Create your FT Tunes account",
    "Upload music & artwork",
    "We deliver to Apple Music & iTunes",
    "Music goes live worldwide",
    "Track streams & analytics",
    "Receive global royalties"
  ];

  return (
<>
<Helmet>

<title>
Distribute Your Music on Apple Music Easily | FT Tunes India
</title>

<meta
name="description"
content="Distribute your music on Apple Music easily with FT Tunes. Get your songs live on Apple Music, iTunes and 150+ platforms. Fast approval, affordable pricing, and full artist support in India."
/>

<meta
name="keywords"
content="Apple Music distribution India, upload music to Apple Music, distribute songs iTunes India, music distribution service India, FT Tunes, release music Apple Music, independent artist distribution Apple Music"
/>

<meta name="robots" content="index, follow" />
<meta name="author" content="FT Tunes" />

{/* Open Graph */}
<meta
property="og:title"
content="Distribute Your Music on Apple Music Easily | FT Tunes India"
/>

<meta
property="og:description"
content="Get your music on Apple Music and iTunes with FT Tunes. Fast, reliable, and affordable music distribution for independent artists in India."
/>

<meta property="og:type" content="website" />

<meta
property="og:url"
content="https://www.fttunes.com/apple-music-distribution"
/>

<meta
property="og:image"
content="https://www.fttunes.com/images/apple-music-distribution.jpg"
/>

{/* Twitter */}
<meta name="twitter:card" content="summary_large_image" />

<meta
name="twitter:title"
content="Distribute Your Music on Apple Music Easily | FT Tunes"
/>

<meta
name="twitter:description"
content="Upload and release your music on Apple Music with FT Tunes. Reach global listeners with ease."
/>

<meta
name="twitter:image"
content="https://www.fttunes.com/images/apple-music-distribution.jpg"
/>

</Helmet>

<div className="apple-page">

{/* ================= HERO ================= */}
<section className="apple-hero">
<Container>

<img style={{width:'35%'}} src="/Images/apple-music-distribution.png" alt="" />

<h1>
Distribute Your Music on <br /> <mark>Apple Music</mark> Easily with FT Tunes
</h1>

<p>
Release your songs globally, reach millions of listeners,
and earn streaming royalties worldwide using FT Tunes music distribution.
</p>

<Button
className="gradient-btn"
href="https://dashboard.fttunes.com/register.php"
target="_blank"
>
Start Distribution
</Button>

</Container>

<div className="hero-glow"></div>
</section>


{/* ================= SHOWCASE ================= */}
<section className="apple-showcase">
<Container>

<Row className="align-items-center">

<Col md={6}>
<h2>Reach Global Apple Music Listeners</h2>

<p>
Apple Music is available in over 160+ countries.
FT Tunes helps independent artists distribute music professionally
while keeping full ownership and control.
</p>

<Button
className="outline-btn"
href="https://dashboard.fttunes.com/register.php"
target="_blank"
>
Distribute Now
</Button>

</Col>

<Col md={6}>
<img
src="/Images/get-your-music-on-apple-music.png"
alt="Apple Music Distribution"
className="apple-image"
/>
</Col>

</Row>

</Container>
</section>


{/* ================= STEPS ================= */}
<section className="apple-steps">
<Container>

<h2 className="section-title">How It Works</h2>

<Row>
{steps.map((step,index)=>(
<Col md={4} key={index}>
<div className="step-card">
<span>0{index+1}</span>
<p>{step}</p>
</div>
</Col>
))}
</Row>

</Container>
</section>


{/* ================= BENEFITS ================= */}
<section className="apple-benefits">
<Container>

<h2 className="section-title">
Why Distribute on Apple Music?
</h2>

<Row>

<Col md={3}>
<div className="benefit-card">
<h5>Global Reach</h5>
<p>Reach millions of Apple Music listeners worldwide.</p>
</div>
</Col>

<Col md={3}>
<div className="benefit-card">
<h5>High Revenue</h5>
<p>Earn competitive streaming payouts & download income.</p>
</div>
</Col>

<Col md={3}>
<div className="benefit-card">
<h5>100% Ownership</h5>
<p>You always keep full rights to your music.</p>
</div>
</Col>

<Col md={3}>
<div className="benefit-card">
<h5>Royalty Collection</h5>
<p>Get paid globally with transparent analytics.</p>
</div>
</Col>

</Row>

</Container>
</section>


{/* ================= CTA ================= */}
<section className="apple-cta">
<Container>

<h2>Start Your Apple Music Journey Today</h2>

<Button
className="gradient-btn big"
href="https://dashboard.fttunes.com/register.php"
target="_blank"
>
Upload Your Music
</Button>

</Container>
</section>

</div>
</>
);
};

export default DistributeAppleMusic;